import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=1bf8ff8f&scoped=true"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"
import style0 from "./Affix.vue?vue&type=style&index=0&id=1bf8ff8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8ff8f",
  null
  
)

export default component.exports